function u(e, n) {
  return e == null ? void 0 : e[n];
}
var a = u;
export {
  a as _
};
